import React from 'react';
import { observer } from "mobx-react";
import Highcharts from 'highcharts/highstock'
import moment from 'moment'

import HighchartWithLoadingSpinner from './HighchartWithLoadingSpinner';
import {countyCovidDataStore, stateCovidDataStore} from '../store/apiStores'
import {regionCovidDataStore} from '../store/apiStores'

function processcountyReportLocationData(data) {
    let infectionData = []
    let deathData = []
    if (data) {
        data.forEach(function(v){
            let date = parseInt(moment.utc(v.report_date).format('x'))
            infectionData.push([date, v.confirmed])
            deathData.push([date, v.deaths])
        });
    }

    return [
        {
            name: 'Cases',
            data: infectionData.sort(),
            color: '#BB301A',
            title_type: 'Total cases and deaths'
        },
        {
            name: 'Deaths',
            data: deathData.sort(),
            color: 'black',
            title_type: 'Total cases and deaths'
        }
    ]
}

function processcountyReportLocationData_one(data, covidField) {
    let covidData = []
    if (data) {
        data.forEach(function(v){
            let date = parseInt(moment.utc(v.report_date).format('x'))
            covidData.push([date, v[covidField]])
        });
    }
    covidData.sort();
    return [
        {
            name: COVID_FIELD_LABELS[covidField],
            data: covidData,
            color: COVID_FIELD_COLORS[covidField],
            title_type: COVID_FIELD_LABELS[covidField]
        }
    ]
}

function thirtydaysago(data) {
    if (!data || data.length == 0 || !data[0].data || data[0].data.length == 0) {
        // data hasn't loaded yet
        return null;
    }
    let last_dates = []
    data.forEach(function(v){
        v.data.sort()
        last_dates.push(v.data[v.data.length - 1][0])
    });
    let last_day = Math.max(...last_dates)
    return(last_day - ((24*60*60*1000) * 30))
}

const COVID_FIELD_LABELS = {
    'confirmed': 'Cases',
    'rate_confirmed': 'Case rate',
    'cdtrailing30': 'Cases 30-day average',
    'cdtrailing7': 'Cases 7-day average',
    'cdtrailing14': 'Cases 14-day average',
    'deaths': 'Deaths',
    'rate_death': 'Death rate',
    'ddtrailing30': 'Deaths 30-day average',
    'ddtrailing7': 'Deaths 7-day average',
    'ddtrailing14': 'Deaths 14-day average',
    'confirmed_last_7_per_100k': '7 day cases per 100,000',
    'deaths_last_7_per_100k': '7 day deaths per 100,000',
    'confirmed_last_14_per_100k': '14 day cases per 100,000',
    'deaths_last_14_per_100k': '14 day deaths per 100,000'
}

const COVID_FIELD_COLORS = {
    'confirmed': '#BB301A',
    'rate_confirmed': '#BB301A',
    'cdtrailing30': '#BB301A',
    'cdtrailing7': '#BB301A',
    'cdtrailing14': '#BB301A',
    'deaths': 'black',
    'rate_death': 'black',
    'ddtrailing30': 'black',
    'ddtrailing7': 'black',
    'ddtrailing14': 'black',
    'confirmed_last_7_per_100k': '#BB301A',
    'deaths_last_7_per_100k': 'black',
    'confirmed_last_14_per_100k': '#BB301A',
    'deaths_last_14_per_100k': 'black'
}

const COVID_FIELD_YAXIS_LABELS = {
    'confirmed': 'People',
    'rate_confirmed': 'Rate per 10,000',
    'deaths': 'People',
    'rate_death': 'Rate per 10,000'
}

const COVID_FIELD_CHART = {
    'confirmed': 'areaspline',
    'rate_confirmed': 'areaspline',
    'cdtrailing30': 'spline',
    'cdtrailing7': 'spline',
    'cdtrailing14': 'spline',
    'deaths': 'areaspline',
    'rate_death': 'areaspline',
    'ddtrailing30': 'spline',
    'ddtrailing7': 'spline',
    'ddtrailing14': 'spline',
    'confirmed_last_7_per_100k': 'spline',
    'deaths_last_7_per_100k': 'spline',
    'confirmed_last_14_per_100k': 'spline',
    'deaths_last_14_per_100k': 'spline'
}


export default observer(function StatecountyCovidAreaspline(props) {
    let seriesData = null;
    let title_text = null;
    if (props.county) {
        if (countyCovidDataStore.data) {
            if (props.covidField2) {
                seriesData = processcountyReportLocationData(countyCovidDataStore.data);
            } else {
                seriesData = processcountyReportLocationData_one(countyCovidDataStore.data, props.covidField);
            }
            title_text = `${props.county} County COVID-19 ` + seriesData[0].title_type
        }
    }
    if (props.state) {
        if (stateCovidDataStore.data) {
            if (props.covidField2) {
                seriesData = processcountyReportLocationData(stateCovidDataStore.data);
            } else {
                seriesData = processcountyReportLocationData_one(stateCovidDataStore.data, props.covidField);
            }
            title_text = `${props.state} State COVID-19 ` + seriesData[0].title_type
        }
    }
    if (props.region) {
        if (regionCovidDataStore.data) {
            if (props.covidField2) {
                seriesData = processcountyReportLocationData(regionCovidDataStore.data);
            } else {
                seriesData = processcountyReportLocationData_one(regionCovidDataStore.data, props.covidField);
            }
            title_text = `${props.region} COVID-19 ` + seriesData[0].title_type
        }
    }

    let options = {

        chart: {
            type: COVID_FIELD_CHART[props.covidField],
            zoomType: 'x',
            animation: false
        },

        title: {
            text: title_text,
            align: 'left'
        },

        time: {
            useUTC: true
        },

        yAxis: {
            title: {
                text: COVID_FIELD_YAXIS_LABELS[props.covidField]
            },
            min: 0,
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            opposite: true
        },

        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                month: '%e. %b',
                year: '%b'
            },
            title: {
                text: 'Date'
            }
        },

        tooltip: {
            pointFormatter: function() {
                if(this.series.name == 'Cases' || this.series.name == 'Deaths') {
                    return '<span style="color:' + this.series.color + ';">●</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(this.y,0) + '</b><br/>';
                } else {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 1) + '</b>';
                }
            }
        },

        plotOptions: {
            spline: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 5
                    }
                },
                marker: {
                    enabled: false
                }
            },
            series: {
                animation: false
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        max: null,
                        min: thirtydaysago(seriesData)
                    }
                }
            }]
        },

        series: seriesData,

        navigation: {
            menuItemStyle: {
                fontSize: '10px'
            }
        }

    }

    return (
        <HighchartWithLoadingSpinner options={options}
            loaded={!!countyCovidDataStore.data || stateCovidDataStore.data || regionCovidDataStore.data}
            dataLength={seriesData && seriesData[0] && seriesData[0].data.length} />
    )
})
